import React from 'react';
import { Link } from 'react-router-dom';
import './Missions.css';

function Missions() {
  const missions = [
    {
      year: "Since 2004",
      location: "Cambodia",
      children: "40-50",
      procedures: "Complex pediatric surgery & urology procedures",
      impact: "Providing life-changing surgical care to children who cannot access these specialized procedures locally due to limited resources and infrastructure",
      status: "ongoing"
    },
    {
      year: "Annual",
      location: "Cambodia", 
      children: "1-2",
      procedures: "Medical missions per year",
      impact: "Regular volunteer missions bringing expert surgical teams to provide complex procedures and train local medical staff",
      status: "recurring"
    }
  ];

  return (
    <div className="missions-page">
      <section className="missions-hero">
        <div className="container">
          <div className="missions-hero-content">
            <span className="missions-badge">Our Impact</span>
            <h1 className="missions-title">Medical Missions</h1>
            <p className="missions-subtitle">
              Delivering expert pediatric surgical care where it's needed most. 
              Our volunteer teams bring hope and healing to children in Cambodia.
            </p>
          </div>
        </div>
        <div className="missions-hero-wave">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z" fill="white"/>
          </svg>
        </div>
      </section>

      <section className="missions-overview">
        <div className="container">
          <div className="stats-grid-missions">
            <div className="stat-mission-card">
              <div className="stat-mission-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3 className="stat-mission-number">300+</h3>
              <p className="stat-mission-label">Children Treated</p>
            </div>

            <div className="stat-mission-card">
              <div className="stat-mission-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
              </div>
              <h3 className="stat-mission-number">40-50</h3>
              <p className="stat-mission-label">Children Per Mission</p>
            </div>

            <div className="stat-mission-card">
              <div className="stat-mission-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5"/>
                  <path d="M2 12l10 5 10-5"/>
                </svg>
              </div>
              <h3 className="stat-mission-number">20+</h3>
              <p className="stat-mission-label">Years of Service</p>
            </div>
          </div>
        </div>
      </section>

      <section className="missions-timeline">
        <div className="container">
          <h2 className="section-title">Recent Missions</h2>
          <div className="timeline">
            {missions.map((mission, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-marker">
                  <div className="timeline-dot"></div>
                  {index !== missions.length - 1 && <div className="timeline-line"></div>}
                </div>
                <div className="timeline-content">
                  <div className="mission-card">
                    <div className="mission-header">
                      <span className="mission-year">{mission.year}</span>
                      <span className={`mission-status ${mission.status}`}>{mission.status}</span>
                    </div>
                    <h3 className="mission-location">{mission.location}</h3>
                    <div className="mission-stats">
                      <div className="mission-stat">
                        <strong>{mission.children}</strong> {typeof mission.children === 'string' && mission.children.includes('-') ? 'missions/children per mission' : 'children per mission'}
                      </div>
                    </div>
                    <p className="mission-procedures">{mission.procedures}</p>
                    <p className="mission-impact">{mission.impact}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="missions-volunteer">
        <div className="container">
          <div className="volunteer-card">
            <div className="volunteer-content">
              <h2>Join Our Next Mission</h2>
              <p>We're always looking for dedicated medical professionals to volunteer their expertise and time to help children in need.</p>
              <Link to="/contact" className="btn-volunteer">
                <span>Get Involved</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Missions;

